let pageStartTime = Date.now()

function getUA() {
  return typeof navigator !== 'undefined' ? navigator.userAgent || '' : ''
}

function getNavigatorObject() {
  return typeof navigator !== 'undefined' ? navigator : null
}

function getWindowObject() {
  return typeof window !== 'undefined' ? window : null
}

function cleanModelName(model = '') {
  return model.replace(/Build\/.*/i, '').replace(/\s{2,}/g, ' ').trim()
}

function isIPadOSLike(ua) {
  const nav = getNavigatorObject()
  if (/iPad/i.test(ua)) return true
  return /Macintosh/i.test(ua) && !!nav && (nav.maxTouchPoints || 0) > 1
}

function detectDeviceType(ua) {
  const nav = getNavigatorObject()
  const win = getWindowObject()
  const width = win ? win.innerWidth || 0 : 0
  const maxTouchPoints = nav ? nav.maxTouchPoints || 0 : 0

  if (isIPadOSLike(ua)) return 'Tablet'
  if (/Tablet|Nexus 7|Nexus 10|KF[A-Z]{2,}|Silk/i.test(ua)) return 'Tablet'
  if (/Windows Phone|IEMobile|Mobile|iPhone|iPod/i.test(ua)) return 'Mobile'

  if (/Android/i.test(ua)) {
    if (/Mobile/i.test(ua)) return 'Mobile'
    if (width && width >= 768) return 'Tablet'
    return maxTouchPoints > 0 ? 'Tablet' : 'Mobile'
  }

  return 'Desktop'
}

function detectOS(ua) {
  const result = {
    osName: '',
    osVersion: '',
  }

  if (/Windows NT/i.test(ua)) {
    result.osName = 'Windows'
    const match = ua.match(/Windows NT ([\d.]+)/i)
    if (match) {
      const versionMap = {
        '10.0': '10',
        '6.3': '8.1',
        '6.2': '8',
        '6.1': '7',
        '6.0': 'Vista',
        '5.1': 'XP',
      }
      result.osVersion = versionMap[match[1]] || match[1]
    }
    return result
  }

  if (/HarmonyOS|OpenHarmony/i.test(ua)) {
    result.osName = 'HarmonyOS'
    const match = ua.match(/(?:HarmonyOS|OpenHarmony)[/\s]([\d.]+)/i)
    if (match) result.osVersion = match[1]
    return result
  }

  if (/Android/i.test(ua)) {
    result.osName = 'Android'
    const match = ua.match(/Android[\s/]([\d.]+)/i)
    if (match) result.osVersion = match[1]
    return result
  }

  if (isIPadOSLike(ua)) {
    result.osName = 'iPadOS'
    const match = ua.match(/OS ([\d_]+)/i)
    if (match) result.osVersion = match[1].replace(/_/g, '.')
    return result
  }

  if (/iPhone|iPod|iOS|CPU(?: iPhone)? OS/i.test(ua)) {
    result.osName = 'iOS'
    const match = ua.match(/OS ([\d_]+)/i)
    if (match) result.osVersion = match[1].replace(/_/g, '.')
    return result
  }

  if (/CrOS/i.test(ua)) {
    result.osName = 'ChromeOS'
    const match = ua.match(/CrOS [^ ]+ ([\d.]+)/i)
    if (match) result.osVersion = match[1]
    return result
  }

  if (/Mac OS X/i.test(ua)) {
    result.osName = 'macOS'
    const match = ua.match(/Mac OS X ([\d_]+)/i)
    if (match) result.osVersion = match[1].replace(/_/g, '.')
    return result
  }

  if (/Linux/i.test(ua)) {
    result.osName = 'Linux'
  }

  return result
}

function detectBrowser(ua) {
  const browserRules = [
    { name: 'WeChat', pattern: /MicroMessenger\/([\d.]+)/i },
    { name: 'QQBrowser', pattern: /(?:MQQBrowser|QQBrowser)\/([\d.]+)/i },
    { name: 'Samsung Internet', pattern: /SamsungBrowser\/([\d.]+)/i },
    { name: 'Huawei Browser', pattern: /HuaweiBrowser\/([\d.]+)/i },
    { name: 'Mi Browser', pattern: /MiuiBrowser\/([\d.]+)/i },
    { name: 'UC Browser', pattern: /UCBrowser\/([\d.]+)/i },
    { name: 'Edge', pattern: /(?:EdgA|EdgiOS|Edg)\/([\d.]+)/i },
    { name: 'Opera', pattern: /(?:OPR|Opera)\/([\d.]+)/i },
    { name: 'Firefox', pattern: /(?:FxiOS|Firefox)\/([\d.]+)/i },
    { name: 'Chrome', pattern: /(?:CriOS|Chrome)\/([\d.]+)/i },
    { name: 'Safari', pattern: /Version\/([\d.]+).*Safari/i },
  ]

  for (const rule of browserRules) {
    const match = ua.match(rule.pattern)
    if (match) {
      return {
        browserName: rule.name,
        browserVersion: match[1] || '',
      }
    }
  }

  return {
    browserName: '',
    browserVersion: '',
  }
}

function detectDeviceBrandAndModel(ua) {
  const rules = [
    {
      brand: 'Apple',
      match: /iPhone/i,
      model: () => 'iPhone',
    },
    {
      brand: 'Apple',
      match: /iPad/i,
      model: () => 'iPad',
    },
    {
      brand: 'Apple',
      match: /iPod/i,
      model: () => 'iPod',
    },
    {
      brand: 'Google',
      match: /\b(Pixel[\sA-Za-z0-9-]+)\b/i,
      model: match => cleanModelName(match[1]),
    },
    {
      brand: 'Samsung',
      match: /\b(SM-[A-Z0-9]+)\b/i,
      model: match => cleanModelName(match[1]),
    },
    {
      brand: 'Huawei',
      match: /\b(HUAWEI[\s-]?[A-Z0-9-]+)\b/i,
      model: match => cleanModelName(match[1]),
    },
    {
      brand: 'Honor',
      match: /\b(HONOR[\s-]?[A-Z0-9-]+)\b/i,
      model: match => cleanModelName(match[1]),
    },
    {
      brand: 'Xiaomi',
      match: /\b((?:Mi|MI|Xiaomi|MIX)[\s-]?[A-Z0-9\s-]+)\b/i,
      model: match => cleanModelName(match[1]),
    },
    {
      brand: 'Redmi',
      match: /\b(Redmi[\s-]?[A-Z0-9\s-]+)\b/i,
      model: match => cleanModelName(match[1]),
    },
    {
      brand: 'POCO',
      match: /\b(POCO[\s-]?[A-Z0-9\s-]+)\b/i,
      model: match => cleanModelName(match[1]),
    },
    {
      brand: 'OnePlus',
      match: /\b(OnePlus[\s-]?[A-Z0-9\s-]+|KB\d{4}|LE\d{4}|IN\d{4})\b/i,
      model: match => cleanModelName(match[1]),
    },
    {
      brand: 'OPPO',
      match: /\b(OPPO[\s-]?[A-Z0-9\s-]+|CPH\d{4})\b/i,
      model: match => cleanModelName(match[1]),
    },
    {
      brand: 'vivo',
      match: /\b(vivo[\s-]?[A-Z0-9\s-]+|V\d{4}[A-Z]?)\b/i,
      model: match => cleanModelName(match[1]),
    },
    {
      brand: 'realme',
      match: /\b(realme[\s-]?[A-Z0-9\s-]+|RMX\d{4})\b/i,
      model: match => cleanModelName(match[1]),
    },
    {
      brand: 'Sony',
      match: /\b(XQ-[A-Z0-9]+|SO-[A-Z0-9]+)\b/i,
      model: match => cleanModelName(match[1]),
    },
  ]

  for (const rule of rules) {
    const match = ua.match(rule.match)
    if (match) {
      return {
        deviceBrand: rule.brand,
        deviceModel: typeof rule.model === 'function' ? rule.model(match) : '',
      }
    }
  }

  if (/Android/i.test(ua)) {
    const genericMatch = ua.match(/Android[\s/][\d.]+;\s*([^;)\]]+)/i)
    if (genericMatch) {
      return {
        deviceBrand: '',
        deviceModel: cleanModelName(genericMatch[1]),
      }
    }
  }

  return {
    deviceBrand: '',
    deviceModel: '',
  }
}

function inferBrandFromModel(model = '') {
  if (!model) return ''
  if (/^SM-/i.test(model)) return 'Samsung'
  if (/^Pixel/i.test(model)) return 'Google'
  if (/^CPH\d+/i.test(model)) return 'OPPO'
  if (/^RMX\d+/i.test(model)) return 'realme'
  if (/^V\d{4}[A-Z]?$/i.test(model)) return 'vivo'
  if (/^(KB|LE|IN)\d{4}/i.test(model)) return 'OnePlus'
  if (/^Redmi/i.test(model)) return 'Redmi'
  if (/^POCO/i.test(model)) return 'POCO'
  if (/^(Mi|MI|Xiaomi|MIX)/i.test(model)) return 'Xiaomi'
  if (/^HUAWEI/i.test(model)) return 'Huawei'
  if (/^HONOR/i.test(model)) return 'Honor'
  return ''
}

async function enrichWithUserAgentData(baseInfo) {
  const nav = getNavigatorObject()
  if (!nav || !nav.userAgentData || typeof nav.userAgentData.getHighEntropyValues !== 'function') {
    return baseInfo
  }

  try {
    const uaData = nav.userAgentData
    const values = await uaData.getHighEntropyValues([
      'model',
      'platform',
      'platformVersion',
      'fullVersionList',
    ])

    const enriched = { ...baseInfo }

    if (!enriched.deviceModel && values.model) {
      enriched.deviceModel = cleanModelName(values.model)
    }

    if (!enriched.deviceBrand && enriched.deviceModel) {
      enriched.deviceBrand = inferBrandFromModel(enriched.deviceModel)
    }

    if (values.platform === 'Windows') {
      enriched.osName = 'Windows'
      const major = parseInt((values.platformVersion || '0').split('.')[0], 10)
      if (!Number.isNaN(major) && major > 0) {
        enriched.osVersion = major >= 13 ? '11' : '10'
      }
    } else if (values.platform === 'Android') {
      enriched.osName = 'Android'
      if (!enriched.deviceType || enriched.deviceType === 'Desktop') {
        enriched.deviceType = uaData.mobile ? 'Mobile' : 'Tablet'
      }
    } else if (values.platform === 'iOS') {
      enriched.osName = enriched.deviceType === 'Tablet' ? 'iPadOS' : 'iOS'
    }

    const fullVersionList = values.fullVersionList || []
    const matchedBrand =
      fullVersionList.find(item => /Microsoft Edge/i.test(item.brand)) ||
      fullVersionList.find(item => /Google Chrome/i.test(item.brand)) ||
      fullVersionList.find(item => /Opera/i.test(item.brand)) ||
      fullVersionList.find(item => /Samsung Internet/i.test(item.brand))

    if (matchedBrand) {
      if (/Microsoft Edge/i.test(matchedBrand.brand)) {
        enriched.browserName = 'Edge'
      } else if (/Google Chrome/i.test(matchedBrand.brand)) {
        enriched.browserName = 'Chrome'
      } else if (/Opera/i.test(matchedBrand.brand)) {
        enriched.browserName = 'Opera'
      } else if (/Samsung Internet/i.test(matchedBrand.brand)) {
        enriched.browserName = 'Samsung Internet'
      }

      enriched.browserVersion = matchedBrand.version || enriched.browserVersion
    }

    return enriched
  } catch (error) {
    return baseInfo
  }
}

export function parseUserAgent() {
  const ua = getUA()
  const osInfo = detectOS(ua)
  const browserInfo = detectBrowser(ua)
  const deviceInfo = detectDeviceBrandAndModel(ua)

  return {
    deviceType: detectDeviceType(ua),
    deviceBrand: deviceInfo.deviceBrand,
    deviceModel: deviceInfo.deviceModel,
    osName: osInfo.osName,
    osVersion: osInfo.osVersion,
    browserName: browserInfo.browserName,
    browserVersion: browserInfo.browserVersion,
    userAgent: ua,
  }
}

export function getScreenInfo() {
  const width =
    typeof screen !== 'undefined'
      ? screen.width
      : typeof window !== 'undefined'
        ? window.innerWidth
        : 0
  const height =
    typeof screen !== 'undefined'
      ? screen.height
      : typeof window !== 'undefined'
        ? window.innerHeight
        : 0

  return {
    screenResolution: `${width}x${height}`,
    colorDepth: typeof screen !== 'undefined' ? screen.colorDepth || screen.pixelDepth || 24 : 24,
  }
}

export function getHardwareInfo() {
  const nav = getNavigatorObject()
  return {
    hardwareConcurrency: nav ? nav.hardwareConcurrency || null : null,
    memoryGb: nav ? nav.deviceMemory || null : null,
  }
}

export function getBrowserCapabilities() {
  const capabilities = {
    jsEnabled: true,
    cookieEnabled: typeof navigator !== 'undefined' ? navigator.cookieEnabled || false : false,
    localStorageSupported: false,
    sessionStorageSupported: false,
    webglSupported: false,
    canvasSupported: false,
  }

  try {
    localStorage.setItem('__aqm_test__', '1')
    localStorage.removeItem('__aqm_test__')
    capabilities.localStorageSupported = true
  } catch (error) {
    capabilities.localStorageSupported = false
  }

  try {
    sessionStorage.setItem('__aqm_test__', '1')
    sessionStorage.removeItem('__aqm_test__')
    capabilities.sessionStorageSupported = true
  } catch (error) {
    capabilities.sessionStorageSupported = false
  }

  try {
    const canvas = document.createElement('canvas')
    capabilities.canvasSupported = !!canvas.getContext('2d')
    capabilities.webglSupported = !!(canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
  } catch (error) {
    capabilities.canvasSupported = false
    capabilities.webglSupported = false
  }

  return capabilities
}

export function getNetworkInfo() {
  const nav = getNavigatorObject()
  const connection = nav
    ? nav.connection || nav.mozConnection || nav.webkitConnection
    : null

  let timezone = 'UTC'

  try {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch (error) {
    timezone = 'UTC'
  }

  return {
    carrier: connection
      ? [connection.type, connection.effectiveType].filter(Boolean).join(' / ')
      : '',
    language: nav ? nav.language || nav.userLanguage || 'en' : 'en',
    timezone,
  }
}

export function getPageStaySeconds() {
  return Math.floor((Date.now() - pageStartTime) / 1000)
}

export function resetPageStartTime() {
  pageStartTime = Date.now()
}

export async function getCompleteDeviceInfo() {
  try {
    const parsedInfo = await enrichWithUserAgentData(parseUserAgent())

    return {
      ...parsedInfo,
      ...getScreenInfo(),
      ...getHardwareInfo(),
      ...getBrowserCapabilities(),
      ...getNetworkInfo(),
      browsingTime: new Date().toISOString(),
      pageStaySeconds: getPageStaySeconds(),
    }
  } catch (error) {
    return {
      deviceType: 'Desktop',
      deviceBrand: '',
      deviceModel: '',
      osName: 'Unknown',
      osVersion: '',
      browserName: 'Unknown',
      browserVersion: '',
      userAgent: getUA(),
      carrier: '',
      language: typeof navigator !== 'undefined' ? navigator.language || 'en' : 'en',
      timezone: 'UTC',
      screenResolution: '0x0',
      colorDepth: 24,
      hardwareConcurrency: null,
      memoryGb: null,
      jsEnabled: true,
      cookieEnabled: false,
      localStorageSupported: false,
      sessionStorageSupported: false,
      webglSupported: false,
      canvasSupported: false,
      browsingTime: new Date().toISOString(),
      pageStaySeconds: 0,
    }
  }
}
